<template>
  <b-card>
    <section>
      <b-row>
        <b-col lg="8">
          <b-card no-body>
            <b-card-body>
              <div v-if="!loading">
                <profile-info :userData="userData" />
              </div>
              <div v-else class="d-flex flex-wrap justify-content-around">
                <b-skeleton width="40%" class="my-1" height="30px"></b-skeleton>
                <b-skeleton width="40%" class="my-1" height="30px"></b-skeleton>
                <b-skeleton width="40%" class="my-1" height="30px"></b-skeleton>
                <b-skeleton width="40%" class="my-1" height="30px"></b-skeleton>
                <b-skeleton width="40%" class="my-1" height="30px"></b-skeleton>
                <b-skeleton width="40%" class="my-1" height="30px"></b-skeleton>
                <b-skeleton width="40%" class="my-1" height="30px"></b-skeleton>
                <b-skeleton width="40%" class="my-1" height="30px"></b-skeleton>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col lg="4">
          <b-card no-body>
            <b-card-header class="font-weight-bolder">
              تغییر رمز عبور
            </b-card-header>
            <b-card-body>
              <profile-change-password />
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <hr class="my-1" v-if="$route.params.id" />
    <section v-if="$route.params.id">
      <b-card-header class="font-weight-bolder pt-0">
        تغییر موبایل یا ایمیل
      </b-card-header>
      <b-row>
        <b-col class="d-flex flex-wrap">
          <b-col lg="6" cols="12">
            <validation-observer ref="editMobile" #default="{ invalid }">
              <b-form
                class="d-flex align-items-center w-100 flex-wrap"
                @submit.prevent="changeMobile"
              >
                <b-button
                  :variant="$route.path.includes('users') ? 'info' : 'primary'"
                  size="md"
                  :type="isChangeMobile ? 'button' : 'submit'"
                  class="my-md-0 my-1"
                  @click="toggleEditMobile"
                  :disabled="isChangeMobile && invalid"
                >
                  {{ isChangeMobile ? "ثبت" : "ویرایش" }}
                </b-button>
                <b-form-group
                  label="موبایل"
                  label-for="edit-phone"
                  class="col-md-7 col-12"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="phone"
                    vid="phone"
                    rules=""
                  >
                    <b-form-input
                      autocomplete="on"
                      id="edit-phone"
                      v-model="phone"
                      name="edit-phone"
                      class="w-100"
                      :readonly="!isChangeMobile"
                      :autofocus="isChangeMobile"
                      :state="
                        isChangeMobile && errors.length > 0 ? false : null
                      "
                    />
                    <small class="text-danger" v-if="isChangeMobile">{{
                      errors[0]
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-form>
            </validation-observer>
          </b-col>
          <b-col lg="6" cols="12">
            <validation-observer ref="editEmail" #default="{ invalid }">
              <b-form
                class="d-flex align-items-center w-100 flex-wrap"
                @submit.prevent="changeEmail"
              >
                <b-button
                  :variant="$route.path.includes('users') ? 'info' : 'primary'"
                  size="md"
                  class="my-md-0 my-1"
                  :type="isChangeMobile ? 'button' : 'submit'"
                  @click="toggleEditEmail"
                  :disabled="isChangeEmail && invalid"
                >
                  {{ isChangeEmail ? "ثبت" : "ویرایش" }}
                </b-button>
                <b-form-group
                  v-if="$route.params.id"
                  label="ایمیل"
                  label-for="edit-email"
                  class="col-md-7 col-12"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    vid="email"
                    rules="required|email"
                  >
                    <b-form-input
                      autocomplete="on"
                      id="edit-email"
                      v-model="email"
                      name="edit-email"
                      :readonly="!isChangeEmail"
                      :autofocus="isChangeEmail"
                      :state="isChangeEmail && errors.length > 0 ? false : null"
                      placeholder="admin@example.com"
                    />
                    <small class="text-danger" v-if="isChangeEmail">{{
                      errors[0]
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-form>
            </validation-observer>
          </b-col>
        </b-col>
      </b-row>
    </section>
    <hr class="my-1" />
    <b-card-header header-tag="div" variant="primary" class="py-0">
      <feather-icon icon="EditIcon" size="21" />
    </b-card-header>
    <b-col class="px-xl-3 px-auto">
      <validation-observer ref="editForm" #default="{ invalid }">
        <b-form class="mt-2 d-flex flex-wrap" @submit.prevent="edit">
          <b-form-group
            label="نام"
            label-for="edit-firstname"
            class="col-xl-4 col-lg-5 col-md-6 col-12 px-sm-3"
          >
            <validation-provider
              #default="{ errors }"
              name="firstname"
              vid="firstname"
              rules="required|totalPerisan"
            >
              <b-form-input
                autocomplete="on"
                id="edit-firstname"
                v-model="firstname"
                name="edit-firstname"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="نام خانوادگی"
            label-for="edit-lastname"
            class="col-xl-4 col-lg-5 col-md-6 col-12 px-sm-3"
          >
            <validation-provider
              #default="{ errors }"
              name="lastname"
              vid="lastname"
              rules="required|min:4|totalPerisan"
            >
              <b-form-input
                autocomplete="on"
                id="edit-lastname"
                v-model="lastname"
                name="edit-lastname"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group
            label="جنسیت"
            label-for="edit-email"
            class="col-xl-4 col-lg-5 col-md-6 col-12 px-sm-3"
          >
            <div class="d-flex pt-50">
              <b-form-radio
                v-model="gender"
                name="gender"
                id="gender-1"
                value="0"
                class="mr-3 custom-control-primary"
              >
                مرد
              </b-form-radio>
              <b-form-radio
                v-model="gender"
                name="gender"
                id="gender-2"
                value="1"
                class="custom-control-primary"
              >
                زن
              </b-form-radio>
            </div>
          </b-form-group>
          <template v-if="$route.params.id">
            <b-form-group
              label="ترم ها"
              label-for="semesters"
              class="col-xl-4 col-lg-5 col-md-6 col-12 px-sm-3"
            >
              <select-box
                id="semesters"
                v-model="semesters"
                select="id"
                multiple
                label="text"
                url="semester"
                searchable
              />
            </b-form-group>
            <b-form-group
              label="دوره ها"
              label-for="courses"
              class="col-xl-4 col-lg-5 col-md-6 col-12 px-sm-3"
            >
              <select-box
                id="courses"
                v-model="courses"
                multiple
                select="id"
                label="text"
                url="course"
                searchable
              />
            </b-form-group>
            <b-form-group
              label="رویداد ها"
              label-for="events"
              class="col-xl-4 col-lg-5 col-md-6 col-12 px-sm-3"
            >
              <select-box
                id="events"
                v-model="events"
                select="id"
                multiple
                label="text"
                url="event"
                searchable
              />
            </b-form-group>
          </template>
          <div
            class="col-xl-4 col-lg-5 col-md-6 col-12 d-flex justify-content-end align-items-center ml-auto pr-3 pr-0"
          >
            <b-button
              :variant="$route.path.includes('users') ? 'info' : 'primary'"
              size="md"
              type="submit"
              :disabled="invalid"
            >
              ویرایش
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-col>
    <loader :loading="loading" />
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BCard,
  BCardHeader,
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BCardTitle,
  BCardText,
  BFormRadio,
  BCardBody,
  BSkeleton,
} from "bootstrap-vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import { required, mobile } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import ProfileChangePassword from "../profile-detail/ProfileChangePassword.vue";
import ProfileInfo from "../profile-detail/ProfileInfo.vue";

export default {
  components: {
    BCard,
    BCardHeader,
    BRow,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormRadio,
    SelectBox,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    Loader,
    ProfileChangePassword,
    ProfileInfo,
    BCardBody,
    BSkeleton,
  },
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      phone: this.userData.mobile || "",
      lastname: this.userData.last_name || "",
      firstname: this.userData.first_name || "",
      email: this.userData.email || "",
      gender: String(this.userData.gender) || "",
      semesters: [],
      courses: [],
      events: [],
      loading: false,
      required,
      mobile,
      isChangeMobile: false,
      isChangeEmail: false,
    };
  },

  watch: {
    email(val) {
      this.email = this.p2e(val).toLowerCase();
    },
    phone(val) {
      this.phone = this.p2e(val);
    },
  },
  created() {
    this.userData.semesters &&
      this.userData.semesters.semesters.map((semester) => {
        this.semesters.push(semester.id);
      });
    this.userData.events &&
      this.userData.events.events.map((event) => {
        this.events.push(event.id);
      });
    this.userData.courses &&
      this.userData.courses.courses.map((course) => {
        this.courses.push(course.id);
      });
  },
  methods: {
    changeMobile() {
      // if (this.isChangeMobile) {
      this.$refs.editMobile.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            if (this.$route.params.id) {
              await this.$http.patch(
                `/panel/users/${this.$route.params.id}/confirm-mobile`,
                {
                  mobile_phone: this.phone,
                }
              );
            }
            this.loading = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: `اطلاعات شما با موفقیت ویرایش شد.`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" }
            );
          } catch (err) {
            this.loading = false;
          }
          this.isChangeMobile = false;
        }
      });
      // } else {
      //   this.isChangeMobile = true;
      // }
    },
    changeEmail() {
      // if (this.isChangeEmail) {
      this.$refs.editEmail.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            if (this.$route.params.id) {
              await this.$http.patch(
                `/panel/users/${this.$route.params.id}/confirm-email`,
                {
                  email: this.email,
                }
              );
            }
            this.loading = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: `اطلاعات شما با موفقیت ویرایش شد.`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" }
            );
          } catch (err) {
            this.loading = false;
          }
          this.isChangeEmail = false;
        }
      });
      // } else {
      //   this.isChangeEmail = true;
      // }
    },
    edit() {
      this.$refs.editForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            if (this.$route.params.id) {
              let user = {
                first_name: this.firstname,
                last_name: this.lastname,
                gender: this.gender,
              };
              this.events.length && (user.events = this.events);
              this.courses.length && (user.courses = this.courses);
              this.semesters.length && (user.semesters = this.semesters);
              await this.$http.put(
                `/panel/users/${this.$route.params.id}`,
                user
              );
            } else {
              await this.$http.put(`/panel/profile`, {
                first_name: this.firstname,
                last_name: this.lastname,
                gender: this.gender,
              });

              const userData = await this.$http.get(`/panel/profile`, {
                params: { includes: ["permissions"] },
              });
              if (localStorage.getItem("tempUserData")) {
                localStorage.setItem(
                  "tempUserData",
                  JSON.stringify({ ...userData.data.data })
                );
              } else {
                localStorage.setItem(
                  "userData",
                  JSON.stringify({ ...userData.data.data })
                );
              }
              this.$store.dispatch("auth/setUserData", {
                ...userData.data.data,
              });
            }
            this.loading = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: `اطلاعات شما با موفقیت ویرایش شد.`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" }
            );
          } catch (err) {
            this.loading = false;
          }
        }
      });
    },
    toggleEditMobile() {
      this.isChangeMobile = !this.isChangeMobile;
    },
    toggleEditEmail() {
      this.isChangeEmail = !this.isChangeEmail;
    },
  },
};
</script>
